import React from 'react';

const FullPageLoader = ({ loading }) => {
    return (
      <>
        {loading && (
          <div className="position-fixed w-100 h-100 d-flex justify-content-center align-items-center bg-light">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            <div className="overlay"></div> 
          </div>
        )}
      </>
    );
  };

export default FullPageLoader;